/* Calzoncillos Fibra de Bambu — landing interactions (prefix: cfb-)
   Native-form friendly: never posts to cart itself; the theme's <product-form>
   + product-form.js own Add-to-Cart and the native cart drawer. */
(function () {
  'use strict';

  var qs = function (s, r) { return (r || document).querySelector(s); };
  var qsa = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  function openCartDrawer() {
    var drawer = qs('cart-drawer');
    if (drawer && typeof drawer.open === 'function') { drawer.open(); return; }
    var bubble = qs('#cart-icon-bubble');
    if (bubble) { bubble.click(); return; }
    window.location.href = (window.routes && window.routes.cart_url) || '/cart';
  }

  /* ---------- HEADER: menu drawer + cart ---------- */
  function initHeader(scope) {
    var header = qs('.cfb-header', scope) || qs('.cfb-header');
    if (!header || header.dataset.cfbInit === '1') { /* still bind cart below */ }
    qsa('[data-cfb-menu-open]', scope).forEach(function (b) {
      b.addEventListener('click', function () {
        var m = qs('.cfb-menu'); if (m) { m.classList.add('is-open'); document.body.classList.add('cfb-noscroll'); }
      });
    });
    qsa('[data-cfb-menu-close]', scope).forEach(function (b) {
      b.addEventListener('click', function () {
        var m = qs('.cfb-menu'); if (m) { m.classList.remove('is-open'); document.body.classList.remove('cfb-noscroll'); }
      });
    });
    qsa('[data-cfb-cart-open]', scope).forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); openCartDrawer(); });
    });
    if (header) header.dataset.cfbInit = '1';
  }

  function updateCartCount(count) {
    qsa('.cfb-cart-count').forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? '' : 'none';
    });
  }

  /* ---------- BUYBOX: size, price, accordions, size guide, gallery, sticky ---------- */
  function initBuybox(scope) {
    var box = qs('.cfb-buybox', scope) || qs('.cfb-buybox');
    if (!box) return;
    if (box.dataset.cfbInit === '1') return;
    box.dataset.cfbInit = '1';

    var form = qs('form[data-type="add-to-cart-form"]', box);
    var idInput = form ? form.querySelector('[name="id"]') : null;
    var errorEl = qs('[data-cfb-size-error]', box);
    var sizeLabel = qs('[data-cfb-size-label]', box);
    var submit = form ? form.querySelector('[type="submit"]') : null;

    /* Size buttons drive the native hidden variant id */
    var sizeBtns = qsa('.cfb-size', box);
    function selectSize(btn) {
      sizeBtns.forEach(function (b) { b.classList.remove('is-selected'); b.setAttribute('aria-pressed', 'false'); });
      btn.classList.add('is-selected'); btn.setAttribute('aria-pressed', 'true');
      if (idInput && btn.dataset.variantId) idInput.value = btn.dataset.variantId;
      if (sizeLabel) sizeLabel.textContent = btn.dataset.size || btn.textContent.trim();
      if (errorEl) errorEl.setAttribute('hidden', '');
      box.dataset.sizeChosen = '1';
    }
    sizeBtns.forEach(function (b) {
      b.addEventListener('click', function () { selectSize(b); });
    });

    /* Require a size before the native submit fires */
    if (form) {
      form.addEventListener('submit', function (e) {
        if (sizeBtns.length && box.dataset.sizeChosen !== '1') {
          e.preventDefault();
          e.stopImmediatePropagation();
          if (errorEl) errorEl.removeAttribute('hidden');
          var list = qs('.cfb-sizes', box);
          if (list) list.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }, true); /* capture: run before product-form.js submit handler */
    }

    /* Accordions (buybox + faq share this) */
    initAccordions(box);

    /* Size guide modal */
    var sg = qs('.cfb-sizeguide');
    qsa('[data-cfb-sizeguide-open]', box).forEach(function (b) {
      b.addEventListener('click', function () { if (sg) { sg.classList.add('is-open'); document.body.classList.add('cfb-noscroll'); } });
    });
    if (sg) {
      qsa('[data-cfb-sizeguide-close]', sg).forEach(function (b) {
        b.addEventListener('click', function () { sg.classList.remove('is-open'); document.body.classList.remove('cfb-noscroll'); });
      });
    }

    initGallery(box);
    initSticky(box);
  }

  /* ---------- Accordions (generic) ---------- */
  function initAccordions(scope) {
    qsa('[data-cfb-accordion]', scope).forEach(function (btn) {
      if (btn.dataset.cfbBound === '1') return; btn.dataset.cfbBound = '1';
      btn.addEventListener('click', function () {
        var item = btn.closest('.cfb-acc__item');
        if (!item) return;
        var open = item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  /* ---------- Gallery: arrows, thumbs, active sync, swipe(native) ---------- */
  function initGallery(scope) {
    var gallery = qs('.cfb-gallery', scope);
    if (!gallery) return;
    var track = qs('.cfb-gallery__track', gallery);
    var slides = qsa('.cfb-gallery__slide', track);
    var thumbs = qsa('.cfb-thumb', scope);
    if (!track || !slides.length) return;

    function goTo(i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      var s = slides[i];
      track.scrollTo({ left: s.offsetLeft - track.offsetLeft, behavior: 'smooth' });
    }
    function current() {
      var w = track.clientWidth || 1;
      return Math.round(track.scrollLeft / w);
    }
    qsa('[data-cfb-arrow]', gallery).forEach(function (a) {
      a.addEventListener('click', function () {
        goTo(current() + (a.getAttribute('data-cfb-arrow') === 'next' ? 1 : -1));
      });
    });
    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () { goTo(i); });
    });
    function setActive() {
      var c = current();
      thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === c); });
    }
    var raf;
    track.addEventListener('scroll', function () {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(setActive);
    });
    setActive();
  }

  /* ---------- Sticky mobile bar ---------- */
  function initSticky(scope) {
    var bar = qs('.cfb-sticky');
    if (!bar) return;
    var mainPrice = qs('[data-cfb-price]', scope);
    var stickyPrice = qs('[data-cfb-sticky-price]', bar);
    var buybox = qs('.cfb-buybox');
    var footer = qs('.cfb-footer') || qs('footer');

    /* Mirror the main price text (works even if an app rewrites it) */
    if (mainPrice && stickyPrice) {
      var sync = function () { stickyPrice.textContent = mainPrice.textContent.trim(); };
      sync();
      try {
        new MutationObserver(sync).observe(mainPrice, { childList: true, characterData: true, subtree: true });
      } catch (e) {}
    }

    /* Click scrolls back to the buy area — never adds to cart */
    qsa('[data-cfb-sticky-cta]', bar).forEach(function (b) {
      b.addEventListener('click', function () {
        var target = qs('.cfb-sizes', scope) || buybox;
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });

    function onScroll() {
      var half = (document.documentElement.scrollHeight - window.innerHeight) * 0.35;
      var scrolled = window.scrollY || window.pageYOffset;
      var boxOut = buybox ? (buybox.getBoundingClientRect().bottom < 80) : (scrolled > half);
      var footerIn = footer ? (footer.getBoundingClientRect().top < window.innerHeight - 20) : false;
      var show = (scrolled > half || boxOut) && !footerIn;
      bar.classList.toggle('is-visible', !!show);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    onScroll();
  }

  /* ---------- CTA buttons that scroll to the buy area (never add to cart) ---------- */
  function initScrollButtons(scope) {
    qsa('[data-cfb-scroll-buy]', scope).forEach(function (b) {
      if (b.dataset.cfbBound === '1') return; b.dataset.cfbBound = '1';
      b.addEventListener('click', function (e) {
        if (b.tagName === 'A' && b.getAttribute('href') && b.getAttribute('href') !== '#') return;
        e.preventDefault();
        var t = qs('.cfb-sizes') || qs('.cfb-buybox');
        if (t) t.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });
  }

  /* ---------- boot ---------- */
  function boot(scope) {
    initHeader(scope);
    initBuybox(scope);
    initAccordions(scope);           /* faq section */
    initScrollButtons(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  /* Live cart count after native add */
  document.addEventListener('DOMContentLoaded', function () {
    if (window.subscribe && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (e) {
        var c = e && e.cartData && (e.cartData.item_count != null ? e.cartData.item_count : (e.cartData.items ? e.cartData.items.length : null));
        if (c != null) updateCartCount(c);
      });
    }
  });

  /* Theme editor: re-init the reloaded section */
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:section:select', function (e) { boot(e.target); });
})();
